import i18n from 'i18n';
import { Action } from 'redux';
import { History } from 'history';
import { showSuccessMessage, showError } from 'shared/toaster';
import { WithAuditDetails } from 'data/types';
import { RootState } from 'data/root.reducers';
import { ThunkDispatch } from 'redux-thunk';
import {
  UPDATE_IP_ASSIGNMENT,
  IpAssignment,
  UpdateIpAssignmentThunkAction,
} from './ipAssignment.types';
import * as api from './ipAssignment.api';
import { extractErrorMessage } from '../../utils';

export function updateIpAssignment(
  deliveryFunctionId: string,
  body: WithAuditDetails<IpAssignment>,
  history: History,
): UpdateIpAssignmentThunkAction {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    try {
      await dispatch({
        type: UPDATE_IP_ASSIGNMENT,
        payload: api.updateIpAssignment(deliveryFunctionId, body),
      });

      showSuccessMessage(i18n.t('ipAssignment.edit.success'));

    } catch (e) {
      const errorMessage = extractErrorMessage(e);
      showError(i18n.t('ipAssignment.edit.failed', { error: errorMessage }));
    }
  };
}
